import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {MessageService} from '@lib-services/message.service';
import {IGroup, IGroupTableData} from '@lib-typing/group.interface';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {GroupsService} from '@lib-services/groups.service';
import {IPaginatedResponse} from '@lib-typing/response.interface';

@Injectable({
    providedIn: 'root',
})
export class GroupTableService implements ICommonTableService<IGroupTableData> {
    public tableData$: BehaviorSubject<CommonTableData<IGroupTableData>> = new BehaviorSubject<CommonTableData<IGroupTableData>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private groupsService: GroupsService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.groupsService
            .getGroups(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(this.transformData(response)));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка групп'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

    transformData(response: IPaginatedResponse<IGroup>): IPaginatedResponse<IGroupTableData> {
        const transformedData = response.data.map(project => {
            return {
                id: project.id,
                createdAt: project.createdAt,
                updatedAt: project.updatedAt,
                executors: project.executors,
                orders: project.orders,
                company: project.company,
                name: project.name,
                companyName: project.company.name,
            } as IGroupTableData;

        });
        // Return a new response object with transformed data
        return {
            ...response,
            data: transformedData
        };
    }
}
